module.exports = __webpack_public_path__ + "img/move03.416eed72.jpg";